import React from "react"
import PropTypes from "prop-types"
import { Link as RouterLink, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import _ from "lodash"
// Material Ui
import { makeStyles } from "@material-ui/core/styles"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"
import useSmartFormat from "../../i18n/useSmartFormat"
// ## //

const useStyles = makeStyles((theme) => ({
  tabItem: {
    paddingTop: 10,
    paddingBottom: 10,
    minWidth: "auto",
    color: theme.palette.text.secondary,
    "&:hover": {
      textDecoration: "none",
      color: theme.palette.text.contrastText
    }
  }
}))

function isVisibleRoute(isLoggedIn) {
  return (route) => {
    if (!route.isVisible) {
      // when no implementation is given for isVisible
      // then consider page as visible
      return true
    }

    return route.isVisible(isLoggedIn)
  }
}

const GenericMenu = ({ routes, subMenu }) => {
  const { pathname } = useLocation()
  const format = useSmartFormat()
  const classes = useStyles()
  const isLoggedIn = useSelector((state) => state.auth.loggedIn)

  // eslint-disable-next-line react/display-name
  const routerLink = React.forwardRef((props, ref) => (
    <RouterLink innerRef={ref} {...props} />
  ))

  const selectedTab = () => {
    const visibleRoutes = _.filter(routes, isVisibleRoute(isLoggedIn))
    const pathIndex = visibleRoutes.findIndex((it) =>
      pathname.startsWith(it.path)
    )

    if (pathIndex !== -1) {
      return pathIndex
    }

    if (subMenu) {
      // trop relou à gérer la fallback pour bien séléctionner le bon menu 0
      // lorsque la route est /wealth
      return 0
    }

    return false
  }

  return (
    <Tabs
      value={selectedTab()}
      indicatorColor="secondary"
      textColor="secondary"
    >
      {routes.map(
        (route) =>
          isVisibleRoute(isLoggedIn)(route) && (
            <Tab
              key={route.title?.id || route.title}
              to={route.path}
              label={format(route.title)}
              classes={subMenu ? { root: classes.tabItem } : {}}
              component={routerLink}
              className={subMenu && "subMenu"}
            />
          )
      )}
    </Tabs>
  )
}

GenericMenu.propTypes = {
  routes: PropTypes.array.isRequired,
  subMenu: PropTypes.bool
}

GenericMenu.defaultProps = {
  subMenu: true
}

export default GenericMenu
